import { authSlice } from './slice'

/* Register User Reducers */
export const { setRegisterStep } = authSlice.actions
export const { resetRegisterState } = authSlice.actions
export const { setCredentials } = authSlice.actions
export const { setRol } = authSlice.actions
export const { setPersonalDetails } = authSlice.actions
export const { setUserRols } = authSlice.actions
export const { setUserIsProducer } = authSlice.actions
export const { setUserIsWidget } = authSlice.actions
export const { setUserhasCommercialCommunications } = authSlice.actions
export const { setPersonalDetailsFirstName } = authSlice.actions
export const { setPersonalDetailsLastName } = authSlice.actions
export const { setUserCredentialsEmail } = authSlice.actions
export const { setUserCompanyName } = authSlice.actions
export const { setUserCountry } = authSlice.actions
export const { setUserPhone } = authSlice.actions
// Create User Reducers
export const { setCreateUserLoading } = authSlice.actions
export const { setCreateUserSuccess } = authSlice.actions
export const { setCreateUserError } = authSlice.actions
export const { resetCreateUserState } = authSlice.actions
// Forgot Password Reducers
export const { setForgotPasswordLoading } = authSlice.actions
export const { setForgotPasswordSuccess } = authSlice.actions
export const { setForgotPasswordError } = authSlice.actions
export const { resetForgotPasswordState } = authSlice.actions
// Restore Password Reducers
export const { setRestorePasswordLoading } = authSlice.actions
export const { setRestorePasswordSuccess } = authSlice.actions
export const { setRestorePasswordError } = authSlice.actions
export const { resetRestorePasswordState } = authSlice.actions
// Login Reducers
export const { setLoginLoading } = authSlice.actions
export const { setLoginSuccess } = authSlice.actions
export const { setLoginError } = authSlice.actions
export const { resetLoginState } = authSlice.actions
// Verify Email Reducers
export const { setVerifyEmailLoading } = authSlice.actions
export const { setVerifyEmailSuccess } = authSlice.actions
export const { setVerifyEmailError } = authSlice.actions
export const { resetVerifyEmailState } = authSlice.actions
// Complete Info Reducers
export const { setCompleteRegisterFormValue } = authSlice.actions
export const { setCompleteUserInfoLoading } = authSlice.actions
export const { setCompleteUserInfoSuccess } = authSlice.actions
export const { setCompleteUserInfoError } = authSlice.actions
export const { resetCompleteUserInfoSubmitState } = authSlice.actions
export const { resetCompleteUserState } = authSlice.actions

export const { setVerifyTokenRedirectLogin } = authSlice.actions
